import { CommonRouter } from '@primeit/components-vue';

CommonRouter.registerRoutes([
  {
    children: [
      {
        component: () => import(/* webpackChunkName: "app.appointment" */ './ListPersonAppointment.vue'),
        meta: {
          label: 'appointment.list',
        },
        path: '',
      },
    ],
    component: () => import(/* webpackChunkName: "app.common" */ '../common/person/Common.vue'),
    meta: {
      icon: 'today',
      label: 'appointment.list_today',
      order: 4,
      userRoles: ['P'],
      visible: true,
      visibleRules: ['allows_hidden_button_schedule'],
    },
    path: '/person/appointment',
  },
  {
    children: [
      {
        component: () => import(/* webpackChunkName: "app.professional" */ './ListProfessionalScheduled.vue'),
        meta: {
          label: 'appointment.list_age',
        },
        path: '',
      },
    ],
    component: () => import(/* webpackChunkName: "app.common" */ '../common/professional/Common.vue'),
    meta: {
      icon: 'today',
      label: 'appointment.list_today',
      order: 2,
      userRoles: ['DC', 'D'],
      visible: true,
    },
    path: '/professional/listscheduled',
  },
  {
    children: [
      {
        component: () => import(/* webpackChunkName: "app.professional" */ './ListProfessionalAppointment.vue'),
        meta: {
          label: 'appointment.list_age',
        },
        path: '',
      },
    ],
    component: () => import(/* webpackChunkName: "app.common" */ '../common/professional/Common.vue'),
    meta: {
      icon: 'list_alt',
      label: 'appointment.list_all',
      order: 3,
      secure: true,
      userRoles: ['DC', 'D'],
      visible: true,
    },
    path: '/professional/listappointment',
  },
  {
    children: [
      {
        component: () => import(/* webpackChunkName: "app.appointment" */ './Detail.vue'),
        meta: {
          label: 'appointment.detail',
          secure: true,
        },
        path: '',
      },
    ],
    component: () => import(/* webpackChunkName: "app.common" */ '../common/professional/Common.vue'),
    meta: {
      icon: 'list_alt',
      label: 'appointment.detail',
      secure: true,
      userRoles: ['DC', 'D'],
      visible: false,
    },
    path: '/appointment/detail/:id',
  },
  {
    children: [
      {
        component: () => import(/* webpackChunkName: "app.appointment" */ './Detail.vue'),
        meta: {
          label: 'appointment.detail',
          secure: true,
        },
        path: '',
      },
    ],
    component: () => import(/* webpackChunkName: "app.common" */ '../common/person/Common.vue'),
    meta: {
      icon: 'list_alt',
      label: 'appointment.detail',
      secure: true,
      userRoles: ['P'],
      visible: false,
    },
    path: '/appointment/detail/:id',
  },
]);
